import React from 'react';
import styles from './Retail.module.css';
import backgroundImage from '../../Images/T18.png';
import T16 from '../../Images/T16.png'; // Import from images folder
import iconT21 from '../../Images/iconT21.png'; 
import iconT22 from '../../Images/iconT22.png';
import iconT23 from '../../Images/iconT23.png';
import iconT24 from '../../Images/iconT24.png';
import iconT25 from '../../Images/iconT25.png';
import iconT26 from '../../Images/iconT26.png';
import iconT30 from '../../Images/iconT30.png';
import T41 from '../../Images/T41.png';
import T42 from '../../Images/T42.png';
import T43 from '../../Images/T43.png';
import T44 from '../../Images/T44.png';
import T52 from '../../Images/T52.png';
import T53 from '../../Images/T53.png';
import T54 from '../../Images/T54.png';
import T55 from '../../Images/T55.png';
import T62 from '../../Images/T62.png';
import icon12 from '../../Images/icon12.png';
import icon15 from '../../Images/icon15.png';
import icon16 from '../../Images/icon16.png';
import icon1 from '../../Images/icon1.png';
import icon2 from '../../Images/icon2.png';
import icon3 from '../../Images/icon3.png';
import icon4 from '../../Images/icon4.png';
import bT1 from '../../Images/bT1.png';
import bT2 from '../../Images/bT2.png';
import bT3 from '../../Images/bT3.png';

// import bg1 from '../../Images/bg1.png';
// import cd1 from '../../Images/cd1.png';
// import cd2 from '../../Images/cd2.png';
// import cd3 from '../../Images/cd3.png';
// import cd4 from '../../Images/cd4.png';
// import sicon1 from '../../Images/sicon1.png';


const Retail = () => {
  const handleCTAClick = (action) => {
    console.log(`${action} clicked`);
    // Add your navigation/modal logic here
  };

  return (
     <div className={styles.container}>
    {/* Hero Section */}
    <section className={styles.heroSection}>
      <div className={styles.heroContent}>
        {/* Top label */}
        <div className={styles.heroLabel}>
          <span className={styles.labelText}>.AI-Powered Retail Solution</span>
        </div>
        
        {/* Main headline */}
        <h1 className={styles.heroHeadline}>
          Boost Your Retail Business with AI-Powered Customer 
          Engagement
        </h1>
        
        {/* Subtext */}
        <p className={styles.heroSubtext}>
          Transform your retail operations 
          with intelligent AI solutions 
  that enhance customer experiences, 
  optimize inventory management, 
  and provide seamless support through AI-powered automation 
  designed specifically for retail businesses.
        </p>
        
        {/* CTA Buttons */}
        <div className={styles.ctaButtons}>
          <button 
            className={`${styles.ctaButton} ${styles.ctaPrimary}`}
            onClick={() => handleCTAClick('Request a Demo')}
          >
            Get Started →
          </button>
          <button 
            className={`${styles.ctaButton} ${styles.ctaSecondary}`}
            onClick={() => handleCTAClick('Learn More')}
          >
            Learn More
          </button>
        </div>
        
        {/* Stats Section */}
<div className={styles.statsSection}>
  <div className={styles.statItem}>
    {/* <img src={icon12} alt="Speed Icon" className={styles.statIcon} /> */}
    <div className={styles.statValue}>85%</div>
    <div className={styles.statLabel}>Customer Satisfaction</div>
  </div>
  <div className={styles.statItem}>
    {/* <img src={icon15} alt="Satisfaction Icon" className={styles.statIcon} /> */}
    <div className={styles.statValue}>60%</div>
    <div className={styles.statLabel}>Response Time Reduced</div>
  </div>
  <div className={styles.statItem}>
    {/* <img src={icon16} alt="Support Icon" className={styles.statIcon} /> */}
    <div className={styles.statValue}>$3M+</div>
    <div className={styles.statLabel}>Revenue Increased</div>
  </div>
</div>
      </div>
      
      {/* Background Image Container */}
      <div className={styles.heroBackground}>
        <div 
          className={styles.backgroundImage}
          // style={{
          //   backgroundImage: `url(${backgroundImage})`,
          // }}
        />
      </div>
    </section>

      {/* Why AI-Powered Software Support
      <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionTitle}>Why AI-Powered Software Support?</h2>
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <h3>24/7 Availability</h3>
              <p>Immediate assistance anytime for software issues.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Automated Fixes</h3>
              <p>AI detects errors and applies solutions instantly.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Reduce Downtime</h3>
              <p>Keep your software running smoothly.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Seamless Integration</h3>
              <p>Works with desktop, web, and mobile applications.</p>
            </div>
          </div>
        </div>
      </section> */}



      {/* Revolutionize Retail with AI */}
<section className={styles.aiSection20}>
  <div className={styles.container20}>
    <div className={styles.contentWrapper20}>
      <div className={styles.headerContent20}>
        <h1 className={styles.title}>
          Revolutionize Retail with <span className={styles.aiText20}>AI</span>
        </h1>
        
        <p className={styles.closingText20}>
          From personalized recommendations to intelligent inventory management, 
          our AI solutions are designed to meet the evolving needs of modern retail businesses.
        </p>
        
        <p className={styles.subtitle20}>
          ToxBox AI helps you transform your retail operations by leveraging cutting-edge 
          artificial intelligence to enhance customer satisfaction, drive sales, and 
          optimize business processes.
        </p>
      </div>
      
      <div className={styles.mainContent20}>
        <div className={styles.imageContainer20}>
          <img 
            src={T16} 
            alt="AI Retail Solutions Dashboard" 
            className={styles.aiImage20}
          />
        </div>
      </div>
    </div>
  </div>
</section>


      {/* Key Features */}
      {/* <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionTitle}>Key Features</h2>
          <div className={styles.featuresList}>
            <div className={styles.featureItem}>
              <h4>Automated Troubleshooting</h4>
              <p>AI identifies bugs, crashes, and compatibility issues.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Patch & Update Management</h4>
              <p>Keep all applications updated automatically.</p>
            </div>
            <div className={styles.featureItem}>   
              <h4>Multi-Channel Support</h4>
              <p>Access via chat, email, or web portal.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Knowledge Base Integration</h4>
              <p>Instant guidance from software manuals and documentation.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Analytics & Insights</h4>
              <p>Monitor software performance and recurring issues.</p>
            </div>
          </div>
        </div>
      </section> */}


        <section className={styles.section21}>
  <div className={styles.container21}>
    {/* Header Section */}
    <div className={styles.headerSection21}>
      <h1 className={styles.title21}>
        AI Capabilities for <span className={styles.highlight21}>Retail</span>
      </h1>
      <p className={styles.subtitle21}>
        Empower your retail business with intelligent AI solutions designed to enhance every aspect of your operations.
      </p>
    </div>

    {/* Capabilities Grid */}
    <div className={styles.capabilitiesGrid21}>
      {/* Card 1 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT21}
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>AI-Powered Customer Service</h3>
        </div>
        <p className={styles.cardDescription21}>
          Provide instant, 24/7 customer support with intelligent chatbots that understand and resolve queries effectively.
        </p>
      </div>

      {/* Card 2 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT22} 
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>Smart Inventory Management</h3>
        </div>
        <p className={styles.cardDescription21}>
          Optimize stock levels with predictive analytics and automated reordering systems powered by AI.
        </p>
      </div>

      {/* Card 3 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT23} 
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>Personalized Recommendations</h3>
        </div>
        <p className={styles.cardDescription21}>
          Increase sales with AI-driven product recommendations tailored to each customer's preferences and behavior.
        </p>
      </div>

      {/* Card 4 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT24} 
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>Sales Analytics & Insights</h3>
        </div>
        <p className={styles.cardDescription21}>
          Make data-driven decisions with advanced analytics that reveal trends and opportunities in real-time.
        </p>
      </div>

      {/* Card 5 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT25} 
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>Customer Behavior Analysis</h3>
        </div>
        <p className={styles.cardDescription21}>
          Understand your customers better with AI-powered insights into shopping patterns and preferences.
        </p>
      </div>

      {/* Card 6 */}
      <div className={styles.capabilityCard21}>
        <div className={styles.cardHeader21}>
          <div className={styles.cardIcon21}>
            <img 
              src={iconT26} 
              alt="Customer Service Icon" 
              className={styles.iconImage21}
            />
          </div>
          <h3 className={styles.cardTitle21}>Quick Insights</h3>
        </div>
        <p className={styles.cardDescription21}>
          Get instant access to actionable insights that help you respond quickly to market changes and customer needs.
        </p>
      </div>
    </div>
  </div>
</section>








      <section className={styles.section22}>
  <div className={styles.container22}>
    <div className={styles.contentWrapper22}>
      {/* Left Side - Text Content */}
      <div className={styles.textContent22}>
        <div className={styles.headerSection22}>
          <h1 className={styles.title22}>
            Transform Your Retail Experience in <span className={styles.highlight22}>3 Steps</span>
          </h1>
        </div>

        {/* Steps List */}
        <div className={styles.stepsList22}>
          {/* Step 1 */}
          <div className={styles.stepItem22}>
            <div className={styles.stepNumberContainer22}>
              <div className={styles.stepNumber22}>1</div>
            </div>
            <div className={styles.stepText22}>
              <h3 className={styles.stepTitle22}>Customer Interactions</h3>
              <p className={styles.stepDescription22}>
                Engage customers with AI-driven chat and email support.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className={styles.stepItem22}>
            <div className={styles.stepNumberContainer22}>
              <div className={styles.stepNumber22}>2</div>
            </div>
            <div className={styles.stepText22}>
              <h3 className={styles.stepTitle22}>Personalized Experience</h3>
              <p className={styles.stepDescription22}>
                Tailor product recommendations based on customer preferences.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className={styles.stepItem22}>
            <div className={styles.stepNumberContainer22}>
              <div className={styles.stepNumber22}>3</div>
            </div>
            <div className={styles.stepText22}>
              <h3 className={styles.stepTitle22}>Insights & Optimization</h3>
              <p className={styles.stepDescription22}>
                Analyze data to optimize operations and drive growth.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Image */}
      <div className={styles.imageContent22}>
        <div className={styles.imageContainer22}>
          <img 
            src={iconT30} 
            alt="Retail Transformation Process" 
            className={styles.mainImage22}
          />
        </div>
      </div>
    </div>
  </div>
</section>




      {/* AI Solutions Across Retail Channels*/}
<section className={styles.section7}>
  <div className={styles.sectionContent7}>
    <h2 className={styles.sectionTitle7}>AI Solutions Across Retail Channels</h2>
    <div className={styles.industryGrid7}>
      <div className={styles.industryCard7}>
        <div className={styles.cardImageContainer7}>
          {/* Replace with actual image path */}
          <img 
            src={T41} 
            alt="Enterprise IT" 
            className={styles.cardImage7}
          />
        </div>
        <h4>E-commerce Stores</h4>
        <p>Enhance your online store with AI-powered product recommendations and customer support.</p>
      </div>
      
      <div className={styles.industryCard7}>
        <div className={styles.cardImageContainer7}>
          {/* Replace with actual image path */}
          <img 
            src={T42} 
            alt="Data Centers" 
            className={styles.cardImage7}
          />
        </div>
        <h4>Fashion & Apparel Retailers</h4>
        <p>Provide personalized styling recommendations and virtual try-on experiences.</p>
      </div>
      
      <div className={styles.industryCard7}>
        <div className={styles.cardImageContainer7}>
          {/* Replace with actual image path */}
          <img 
            src={T43} 
            alt="Healthcare" 
            className={styles.cardImage7}
          />
        </div>
        <h4>Electronics Retail</h4>
        <p>Offer intelligent product comparisons and technical support through AI assistants.</p>
      </div>
      
      <div className={styles.industryCard7}>
        <div className={styles.cardImageContainer7}>
          {/* Replace with actual image path */}
          <img 
            src={T44}
            alt="Education" 
            className={styles.cardImage7}
          />
        </div>
        <h4>Mobile & Omnichannel</h4>
        <p>Deliver seamless experiences across all channels with unified AI solutions.</p>
      </div>
    </div>
  </div>
</section>


      {/* Why Choose ToxBox AI for Retail?*/}
      <section className={styles.section23}>
  <div className={styles.container23}>
    {/* Header Section */}
    <div className={styles.headerSection23}>
      <h1 className={styles.title23}>
        Why Choose ToxBox AI for <span className={styles.highlight23}>Retail?</span>
      </h1>
      <p className={styles.subtitle23}>
        Transform your retail operations with AI-powered solutions that deliver measurable results.
      </p>
    </div>

    {/* Capabilities Grid */}
    <div className={styles.capabilitiesGrid23}>
      {/* Card 1 */}
      <div className={styles.capabilityCard23}>
        <div className={styles.cardHeader23}>
          <div className={styles.cardIcon23}>
            <img 
              src={T52}
              alt="Customer Service Icon" 
              className={styles.iconImage23}
            />
          </div>
          <h3 className={styles.cardTitle23}>AI-Powered Customer Service</h3>
        </div>
        <p className={styles.cardDescription23}>
          Provide instant, 24/7 customer support with intelligent chatbots that understand and resolve queries effectively.
        </p>
      </div>

      {/* Card 2 */}
      <div className={styles.capabilityCard23}>
        <div className={styles.cardHeader23}>
          <div className={styles.cardIcon23}>
            <img 
              src={T53} 
              alt="Customer Service Icon" 
              className={styles.iconImage23}
            />
          </div>
          <h3 className={styles.cardTitle23}>Smart Inventory Management</h3>
        </div>
        <p className={styles.cardDescription23}>
          Optimize stock levels with predictive analytics and automated reordering systems powered by AI.
        </p>
      </div>

      {/* Card 3 */}
      <div className={styles.capabilityCard23}>
        <div className={styles.cardHeader23}>
          <div className={styles.cardIcon23}>
            <img 
              src={T54} 
              alt="Customer Service Icon" 
              className={styles.iconImage23}
            />
          </div>
          <h3 className={styles.cardTitle23}>Personalized Recommendations</h3>
        </div>
        <p className={styles.cardDescription23}>
          Increase sales with AI-driven product recommendations tailored to each customer's preferences and behavior.
        </p>
      </div>

      {/* Card 4 */}
      <div className={styles.capabilityCard23}>
        <div className={styles.cardHeader23}>
          <div className={styles.cardIcon23}>
            <img 
              src={T55} 
              alt="Customer Service Icon" 
              className={styles.iconImage23}
            />
          </div>
          <h3 className={styles.cardTitle23}>Sales Analytics & Insights</h3>
        </div>
        <p className={styles.cardDescription23}>
          Make data-driven decisions with advanced analytics that reveal trends and opportunities in real-time.
        </p>
      </div>

      
    </div>
  </div>
</section>

      <section className={styles.ctaSection24}>
  <div className={styles.container24}>
    <div className={styles.ctaContent24}>
      {/* Left Side - Image */}
      <div className={styles.ctaImageContainer24}>
        <img 
          src={T62} 
          alt="AI Retail Dashboard" 
          className={styles.ctaImage24}
        />
      </div>

      {/* Right Side - Text Content */}
      <div className={styles.ctaTextContent24}>
        <div className={styles.ctaCard24}>
          <h2 className={styles.ctaTitle24}>
            Elevate Your Retail Experience with <span className={styles.ctaHighlight24}>AI Today</span>
          </h2>
          
          <p className={styles.ctaDescription24}>
            Join thousands of retailers who are already leveraging ToxBox AI to transform their customer experiences and drive unprecedented growth. Start your AI journey today.
          </p>
          
          <button className={styles.ctaButton24}>
            Get Started
            <span className={styles.arrowIcon24}>→</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
    </div>
  );
};

export default Retail;
